let calculationsSubmited = false;
positionsCounters = [
  {
    id: 0,
    counterName: "frontend-devs",
    count: 0,
    name: "Frontend Dev",
    cost: 45,
  },
  {
    id: 1,
    counterName: "backend-devs",
    count: 0,
    name: "Backend Dev",
    cost: 45,
  },
  {
    id: 2,
    counterName: "qa-devs",
    count: 0,
    name: "QA Dev",
    cost: 35,
  },
  {
    id: 3,
    counterName: "project-managers",
    count: 0,
    name: "Project Manager",
    cost: 35,
  },
  {
    id: 4,
    counterName: "ux-designers",
    count: 0,
    name: "UX/UI Designer",
    cost: 35,
  },
  {
    id: 5,
    counterName: "dev-ops",
    count: 0,
    name: "Dev Ops",
    cost: 50,
  },
  {
    id: 6,
    counterName: "tech-lead",
    count: 0,
    name: "Tech Lead",
    cost: 55,
  },
  {
    id: 7,
    counterName: "full-stack-devs",
    count: 0,
    name: "Full Stack Dev",
    cost: 50,
  },
]

positionsCounters.forEach(setCounterListeners);

function setCounterListeners(item) {
  document.getElementById(item.counterName + '-increase').addEventListener("click",  function(){
    increaseCount(item);
  });
  document.getElementById(item.counterName + '-decrease').addEventListener("click",  function(){
    decreaseCount(item);
  });
}

document.getElementById("months").addEventListener("change",  updateMonths);
document.getElementById("to-send-button").addEventListener("click",  initForm);

let costs = 0;
let months = 3;

function increaseCount(counter) {
  if (!calculationsSubmited) {
    let position = document.getElementById(counter.counterName);
    let row = position.parentElement.parentElement;
    let decreaseButton = document.getElementById(counter.counterName + '-decrease');
    let increaseButton = document.getElementById(counter.counterName + '-increase');
    let count = positionsCounters[counter.id].count;
    if (count < 100) {
      count++;
      positionsCounters[counter.id] = {...counter, count};
      position.innerHTML = count.toString();
      refreshSummary();
      row.classList.add("selected");
      decreaseButton.classList.remove("disabled");
      increaseButton.classList.remove("accent");
    } else {
      increaseButton.classList.add("disabled");
    }
  }
}

function decreaseCount(counter) {
  if (!calculationsSubmited) {
    let position = document.getElementById(counter.counterName);
    let row = position.parentElement.parentElement;
    let decreaseButton = document.getElementById(counter.counterName + '-decrease');
    let increaseButton = document.getElementById(counter.counterName + '-increase');
    let count = positionsCounters[counter.id].count;
    if (count > 0) {
      count--;
      if (count === 0) {
        row.classList.remove("selected");
        decreaseButton.classList.add("disabled");
        increaseButton.classList.add("accent");
      }
      positionsCounters[counter.id] = {...counter, count};
      position.innerHTML = count.toString();
      refreshSummary();
    }
  }
}

let positionsSummary = document.getElementById("positions-summary");
let estimatedCosts = document.getElementById("estimated-costs");
function refreshSummary() {
  positionsSummary.innerHTML = '';
  costs = 0;
  positionsCounters.forEach(refreshData);
  if(positionsSummary.innerHTML !== '') {
    positionsSummary.innerHTML += "<div class='positions-summary__element'><div class='quantity__button positions-summary__count'>&#8734;</div><p class='positions-summary__name'>Onboarding Service</p></div>"
  }
  calculateEstimatedCosts();
}

function refreshData(item) {
  showPositionData(item);
  calculatePositionCost(item);
}

function showPositionData(item) {
  let positionName = item.name;
  let count = item.count;
  if (item.count > 0) {
    positionsSummary.innerHTML += "<div class='positions-summary__element'><div class='quantity__button positions-summary__count'>" + count + "</div>" + "<p class='positions-summary__name'>" + positionName + "</p></div>"
  }
}

function calculatePositionCost(item) {
  costs += item.cost * item.count * 160;
}

let wholeCosts = 0;
let minCosts = '';
let maxCosts = '';
function calculateEstimatedCosts() {
  wholeCostsElement = '';
  wholeCosts = 0;
  wholeCosts = costs * months;
  if (wholeCosts === 0) {
    estimatedCosts.innerHTML = wholeCosts.toString();
  } else {
    minCosts = numberWithCommas(Math.round(wholeCosts * 0.9));
    maxCosts = numberWithCommas(Math.round(wholeCosts * 1.1));
    estimatedCosts.innerHTML =  minCosts + ' - ' + maxCosts;
  }
}

function updateMonths() {
  months = document.getElementById('months').value;
  let monthsLabel = document.getElementById('months-value');
  monthsLabel.innerHTML = months;
  calculateEstimatedCosts();
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

let submitedEstimatedCosts = document.getElementById("submited-estimated-costs");
let submitedMonthsValue = document.getElementById("submited-months-value");
let submitedPositions = '';

function initForm() {
  calculationsSubmited = true;
  submitedEstimatedCosts.innerHTML =  minCosts + ' - ' + maxCosts;
  submitedMonthsValue.innerHTML = months;
  let summary = document.getElementById('summary');
  let summarySending = document.getElementById('summary-sending');
  summary.style.display = 'none';
  summarySending.style.display = 'flex';
  positionsCounters.forEach(getPositions);
}

function getPositions(item) {
  if (item.count !== 0) {
    submitedPositions += item.name + ": " + item.count + "<br/>";
  }
}

document.addEventListener('DOMContentLoaded', () => {

  document.querySelector('form').addEventListener('submit', (ev) => {
    ev.preventDefault();
    const email = ev.target.elements.modal_mail.value;
    const phone = ev.target.elements.modal_phone.value;
    const name = ev.target.elements.modal_name.value;
    const message = `IMIĘ ${name} <br/>EMAIL: ${email} <br/>TELEFON: ${phone} <br/>MONTHS: ${months} <br/> EST. COST: ${minCosts} - ${maxCosts} <br/> POSITIONS:<br/> ${submitedPositions}`;

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.g-group.dev/action/sendEmail`, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("x-access-token", "@o8lIF#dlI@FtdK&U@^DFi57ksf5i72kdust");
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if(xhr.response.includes("<head>")){
          window.location.replace('/admin');
        }
        if(JSON.parse(xhr.response).status == true){
          document.getElementById("email_success_message").innerText = "Message sent succesfully"
          document.getElementById("summary-name").value = ""
          document.getElementById("summary-email").value = ""
          document.getElementById("summary-phone").value = ""
          console.log("sending success")
        } else {
          document.getElementById("email_failure_message").innerText = "Message delivery failed, please try again or contact us by phone"
          console.log("sending failed")
        }
      }
    }
    xhr.send(JSON.stringify({
      message: message,
      modal_email: email,
      modal_name: name
    }));

  })
})
